import {
  Anchor,
  Box,
  Button,
  CloseButton,
  createStyles,
  Modal,
  Stack,
  Text,
  Title,
} from '@mantine/core';
import React from 'react';

import { useRequestPlanUpgrade } from '@portals/api/partners';
import { ModalProps } from '@portals/framework';
import { Spaceship } from '@portals/framework/icons';

export interface UpgradePricingPlanProps
  extends ModalProps<{
    source: string;
  }> {}

export function UpgradePricingPlan({
  closeMe,
  data: { source },
}: UpgradePricingPlanProps) {
  const { classes } = useStyles();
  const requestPlanUpgrade = useRequestPlanUpgrade();

  const onContact = () => {
    requestPlanUpgrade.mutate(source);

    closeMe();
  };

  return (
    <Modal
      opened={true}
      onClose={closeMe}
      withinPortal
      withCloseButton={false}
      padding={0}
      size={700}
      classNames={{
        content: classes.modalContent,
      }}
    >
      <Box className={classes.container}>
        <CloseButton
          onClick={closeMe}
          className={classes.closeButton}
          size="lg"
        />

        <Spaceship />

        <Stack className={classes.content} justify="space-between">
          <Stack>
            <Title order={4} weight={500} color="blue_gray.9">
              Upgrade to access this feature
            </Title>

            <Text size="sm" color="blue_gray.5">
              You have hit your current plan's limitation. Please upgrade to
              unlock this and a wide range of other powerful features offered by
              the Xyte platform.
              <br />
              <br />
              Explore the different plans available at{' '}
              <Anchor href="https://www.xyte.io/pricing" target="_blank">
                xyte.io/pricing
              </Anchor>{' '}
              or get in touch with us to learn more. We're always here to help
              you make the most of our platform.
            </Text>
          </Stack>

          <Button onClick={onContact}>Contact Us</Button>
        </Stack>
      </Box>
    </Modal>
  );
}

const useStyles = createStyles((theme) => ({
  modalContent: {
    overflow: 'hidden',
  },
  container: {
    display: 'grid',
    gridTemplateColumns: '261px 1fr',
    height: '100%',
    position: 'relative',
    gap: theme.spacing.xl,
  },
  closeButton: {
    position: 'absolute',
    top: 20,
    right: 20,
  },
  content: {
    padding: '72px 40px 32px 0',
    height: '100%',
  },
}));
